import { SearchRequest, SearchResponse, Movie } from '../types/movie';
import { MOVIES_DATABASE } from '../data/movies';
import { normalizeQuery } from '../utils/cache';

// LLM API 调用（仿PSP模式）
export async function searchMoviesWithLLM(
  query: string,
  preferences?: SearchRequest['preferences']
): Promise<SearchResponse> {
  // 归一化查询
  const normalizedQuery = normalizeQuery(query);

  // 检查缓存
  const cacheKey = `search_${normalizedQuery}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    return JSON.parse(cached);
  }

  // 本地搜索匹配（第一阶段：无需LLM）
  const localResults = searchLocalMovies(query, preferences);

  if (localResults.length > 0) {
    const response: SearchResponse = {
      movies: localResults,
      reasoning: `根据"${query}"找到了${localResults.length}部匹配的电影`
    };

    // 缓存结果
    localStorage.setItem(cacheKey, JSON.stringify(response));
    return response;
  }

  // 如果本地没有匹配，返回空（第二阶段可以集成LLM）
  const emptyResponse: SearchResponse = {
    movies: [],
    reasoning: '抱歉，没有找到匹配的电影。试试更具体的描述，比如类型、情绪或主题。'
  };

  return emptyResponse;
}

// 本地电影搜索
function searchLocalMovies(
  query: string,
  preferences?: SearchRequest['preferences']
): Movie[] {
  const lowerQuery = query.toLowerCase();
  let results = MOVIES_DATABASE;

  // 关键词匹配
  results = results.filter(movie => {
    const searchText = [
      movie.title,
      movie.titleEn || '',
      movie.director,
      movie.actors.join(' '),
      movie.description,
      movie.recommendation || '',
      movie.tags.join(' '),
      movie.genre.join(' ')
    ].join(' ').toLowerCase();

    return searchText.includes(lowerQuery);
  });

  // 应用筛选条件
  if (preferences) {
    if (preferences.genre) {
      results = results.filter(m => m.genre.includes(preferences.genre));
    }
    if (preferences.minRating) {
      results = results.filter(m =>
        (m.rating.douban || 0) >= preferences.minRating!
      );
    }
    if (preferences.year) {
      results = results.filter(m => {
        if (preferences.year!.from && m.year < preferences.year!.from) return false;
        if (preferences.year!.to && m.year > preferences.year!.to) return false;
        return true;
      });
    }
  }

  // 按评分排序
  results.sort((a, b) => (b.rating.douban || 0) - (a.rating.douban || 0));

  return results.slice(0, 6); // 最多返回6部
}

// 获取热门电影
export function getTrendingMovies(): Movie[] {
  return [...MOVIES_DATABASE]
    .sort((a, b) => (b.rating.douban || 0) - (a.rating.douban || 0))
    .slice(0, 6);
}

// 根据ID获取电影
export function getMovieById(id: string): Movie | undefined {
  return MOVIES_DATABASE.find(m => m.id === id);
}
